export class ChatAttachmentWarning {
  messages: string[];
  fileName?: string;

  constructor(message: string[], fileName?: string) {
    this.messages = message;
    this.fileName = fileName;
  }
}
